export const cartDataMapper = (data: any) => {
  const newData = data?.map((product: any) => {
    return {
      id: product?.productId,
      name: product?.name,
      price: +product?.priceInCents / 100,
      quantity: +product?.quantity,
      unit: +product?.unit,
      image: product?.imageMasterUrl,
    };
  });
  return newData;
};
